function useMyTeam() {
  return {};
}

export default useMyTeam;
